<template>
  <div class="exchange-item">
    <div
      class="row-justify item-container"
      :class="data.type == 'buy' ? 'in' : 'out'"
    >
      <div class="col item-col--left" @click="onAvatarDivClick">
         <img
          class="avatar"
          :src="data.user.avatarUrl || defaultAvatarUrl"
          :alt="data.user.nickname"
        />
        <div class="name">{{ data.user.nickname }}</div>

        <div class="exchange-count">
          <svg class="icon">
            <use xlink:href="#icon-order-trades2" />
          </svg>
          {{data.user.multisigOrderCount}}
        </div>
        <div class="exchange-count">
          <svg class="icon">
            <use xlink:href="#icon-order-fast2" />
          </svg>
          {{ data.user.in5minRate | formatRate }}
        </div>
        <div class="exchange-count">
          <svg class="icon">
            <use xlink:href="#icon-order-complete2" />
          </svg>
          {{ data.user.orderSuccessRank | formatRate }}
        </div>
        <div class="exchange-count">
          <svg class="icon">
            <use xlink:href="#icon-order-praise2" />
          </svg>
          {{ data.user.rateRank | formatRate }}
        </div>

      </div>
      <div class="col item-col--mid">
        <div class="pay-range">
          <span>{{ +data.minPrice }}</span>
          <span class="division">~</span>
          <span>{{ +data.maxPrice }}</span>
          <span class="unit">{{ legalCurrency && legalCurrency.unit }}</span>
        </div>
        <div class="tag ">
          <div class="nation" v-if="location">
          <span
            v-if="location.name"
            class="flag-icon flag-icon-squared"
            :class="`flag-icon-${location.name.toLowerCase()}`"
          ></span>
          <span v-if="location.name && navLangMain" class="text">
            {{ $root.countries.getName(location.name, navLangMain) }}
          </span>
         </div>
          <span class="tag-item" v-if="data.user.hasCertified">
            <svg class="icon">
              <use xlink:href="#icon-certified-colorful" />
            </svg>
            <span>{{ $t('exchange.blueTrust') }}</span>
          </span>
          <span class="tag-item tag-video" v-if="data.user.hasVideo">
            <svg class="icon">
              <use xlink:href="#icon-video2" />
            </svg>
            <span>{{ $t('exchange.kycVideo') }}</span>
          </span>
          <span class="tag-item" v-if="data.user.hasVerified">
            <svg class="icon">
              <use xlink:href="#icon-verified" />
            </svg>
            <span>{{ $t('exchange.kyc') }}</span>
          </span>

          <span class="tag-item" v-if="data.isCheck" >
            <svg class="icon">
              <use xlink:href="#icon-check2" />
            </svg>
            <span>{{ $t('exchange.optionalMode') }}</span>
          </span>


        </div>

        <div class="pay-info-wrapper">
        <span 
          class="pay-info"
          v-for="payMethod in payMethods"
          :key="payMethod.value"
        >
        <svg class="icon-shu">
              <use xlink:href="#icon-shu2" />
        </svg>
        {{ $t(`payments.${payMethod.name}`) }}
        </span>
        </div>

        <div
          class="pay-remark"
          :ref="'payRemark' + data.id"
          @click="showAllTitle(data.id)"
        >
          {{ data.title }}
        </div>

        <div class="timezone">{{ timeText }}</div>
      </div>
      <div class="col item-col--right">

        <div class="total row">
          <span
            :class="['total-num', 'num-font', getFontSize(String(data.price))]"
          >
            {{ data.price }}
          </span>
          <span class="unit">{{ legalCurrency && legalCurrency.unit }}</span>
        </div>
        <div class="operation row-align-center" v-if="asset">
          <img :src="asset.iconUrl" :alt="asset.name" class="icon" />
          <span class="asset-symbol">
            {{ asset.symbol }}
          </span>
        </div>
        <div class="action" v-if="showBtn">
          <md-button
            :type="data.type == 'sell' ? 'primary' : 'warning'"
            @click="onBtnClick"
          >
            <span v-if="data.type == 'sell'">{{ $t('exchange.buy') }}</span>
            <span v-else>{{ $t('exchange.sell') }}</span>
          </md-button>
        </div>
        <div
          class="attribute-text row-align-center"
          v-if="showAttribute"
          :class="!+data.attribute ? 'public' : 'private'"
        >
          <svg class="attribute-icon">
            <use
              :xlink:href="`#icon-${!+data.attribute ? 'public' : 'private'}`"
            />
          </svg>
          <span>{{ $t(`createPost.${!+data.attribute ? 'public' : 'private'}`) }}</span>
        </div>
      </div>
    </div>

    
    <md-dialog
      :title="this.$t('common.tradeDataTipsTitle')"
      :mask-closable="true"
      v-model="tradeDataDialog.open"
      :btns="tradeDataDialog.btns"
    >
        
    <span class="exchange-popup-span">{{ $t('common.tradeDataTipsTitleSub') }}</span>
        <p style="margin-top: 5px;"></p>
        <div class="exchange-popup-div">
          <svg class="icon">
            <use xlink:href="#icon-order-trades2" />
          </svg>
          {{data.user.multisigOrderCount}}  - {{ $t('common.tradeDataTipsText1') }}
        </div>
        <div class="exchange-popup-div">
          <svg class="icon">
            <use xlink:href="#icon-order-fast2" />
          </svg>
          {{data.user.in5minRate | formatRate}}  - {{ $t('common.tradeDataTipsText2') }}
        </div>
        <div class="exchange-popup-div">
          <svg class="icon">
            <use xlink:href="#icon-order-complete2" />
          </svg>
          {{data.user.orderSuccessRank | formatRate}}  - {{ $t('common.tradeDataTipsText3') }}
        </div>
        <div class="exchange-popup-div">
          <svg class="icon">
            <use xlink:href="#icon-order-praise2" />
          </svg>
          {{data.user.rateRank | formatRate}}  - {{ $t('common.tradeDataTipsText4') }}

        </div>
        <span class="exchange-popup-span"> {{ $t('common.tradeDataTipsZhushi') }}</span>
        <p style="margin-top: 5px;"></p>
    </md-dialog>



  </div>
</template>

<script>
import getPayIcon from '@/utils/get-payment-icon.js';
import { mapState } from 'vuex';
import { Button, Dialog } from 'mand-mobile';
export default {
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      defaultAvatarUrl:
        '/storage/images/tigalocal.png',
      tradeDataDialog: {
        open: false,
        btns: [
          {
            text: this.$t('common.confirm'),
            warning: false,
            handler: this.onTradeDataConfirm,
          },
        ],
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    showBtn: {
      type: Boolean,
      default: false,
    },
    showAttribute: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formatRate(num) {
      num = (num * 100).toFixed(2);
      return `${+num}%`;
    },
  },
  computed: mapState({
    userInfo: state => state.userInfo,
    navLang: state => state.navLang,
    navLangMain: state => state.navLangMain,
    cryptoList: state => state.settings.cryptoList,
    locationList: state => state.settings.locationList,
    legalCurrencyList: state => state.settings.legalCurrencyList,
    paymentList: state => state.settings.paymentList,
    asset() {
      return this.cryptoList.find(item => item.id == this.data.assetId);
    },
    payMethods() {
      const list = [];
      this.paymentList.forEach(item => {
        if (this.data.payMethodIds.includes(item.id)) {
          list.push({
            value: item.id,
            label: this.$t(`payments.${item.name}`),
            method: item.value,
            name: item.name,
          });
        }
      });
      return list;
    },
    legalCurrency() {
      return this.legalCurrencyList.find(item => item.id == this.data.legalCurrencyId);
    },
    location() {
      return this.locationList.find(item => item.id == this.data.locationId);
    },
    exchangeTag() {
      return `#icon-medal-${this.navLangMain}`;
    },
    timeText() {
      const { zone, ontimeStart, ontimeEnd } = this.data;
      if (isNaN(zone) || isNaN(ontimeStart) || isNaN(ontimeEnd)) {
        return '';
      }
      return `(GMT${
        zone >= 0 ? `+${zone}` : zone
      }:00 ${ontimeStart}:00-${ontimeEnd}:00)`;
    },
  }),
  created(){
    
  },
  methods: {
    getPayIcon(payMethod) {
      return getPayIcon.call(null, payMethod);
    },
    getFontSize(str) {
      if (str.length > 8) {
        return 'small';
      }
      return '';
    },
    onBtnClick() {
      this.$emit('btn-click');
    },
    showAllTitle(id) {
      let className = this.$refs['payRemark' + id].className;
      if (className === '') {
        this.$refs['payRemark' + id].className = 'pay-remark';
      } else {
        this.$refs['payRemark' + id].className = '';
      }
    },
    onAvatarDivClick() {
      this.tradeDataDialog.open = true;
    },
    onTradeDataConfirm() {
      this.tradeDataDialog.open = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.exchange-item {
  margin-top: 1.8vw;
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    absolute-pos();
    z-index: 10;
    border: 0.27vw solid #eaf1f3;
    border-top-style: hidden;
    border-left-style: hidden;
    border-right-style: hidden;

  }

  .item-container {
    position: relative;
    z-index: 100;
    padding: 2.18vw;
  }

  .avatar {
    box-sizing: border-box;
    border: 0.27vw solid #eaf1f3;
    width: 5.68vw;
    height: 5.68vw;
    border-radius: 1.68vw;
  }

  .name {
    max-width: 16vw;
    font-size: 2.68vw;
    line-height: 3.18vw;
    font-weight: 600;
    word-ellipsis();
    margin-top: 1vw;
    margin-bottom: 1vw;
  }

  .exchange-count {
    font-size: 2.13vw;
    color: #84969c;
    align-items:center;
    .icon {
      width: 2.18vw;
      height: 2.18vw;
     }
  }
  .nation {
    font-size: 2.13vw;
    color: #84969C;
    margin-right:1vw;

    .text {
      max-width: 10vw;
      word-ellipsis();
    }

    .flag-icon {
      width: 2.58vw;
      height: 2.58vw;
    }
  }

  .exchange-tag {
    margin-top: 1.07vw;
    width: 16vw;
    height: 3.73vw;
  }

  .pay-info-wrapper {
    margin-bottom: 1.07vw;
    font-size: 2.68vw;
    color: #2c3133;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
      .icon-shu {
        height: 2.18vw;
        width: 2.18vw;
        color: #d3d4d8;
      }
  }

  .pay-range {
    margin-bottom: 0.88vw;
    color: #dc521b;
    font-size: 2.98vw;

    .unit {
      margin-left: 0.53vw;
      font-size: 1.6vw;
    }

    .division {
      margin: 0 0.53vw;
    }
  }

  .tag {
    font-size: 2.13vw;
    color: color-primary;
    display: flex;
    flex-wrap: wrap;

    .tag-item {
      display:inline-flex;
      align-items: center; 
      padding-left: 1vw;
      padding-right: 1vw; 
    }  
    .tag-item:nth-child(n) {
      padding-left: 0;
    }   

    .icon {
      margin-right: 0.5vw;
      width: 2.67vw;
      height: 2.67vw;
    }
  }

  .timezone {
    margin-top:0.18vw;
    font-size: 2.13vw;
    color: #84969C;
  }

  .item-col--left {
    flex: 0 0 13.8vw;
  }

  .item-col--mid {
    margin-left: 2.13vw;
    font-size: 2.88vw;
    flex: 1 0 0%;
  }

  .item-col--right {
    align-items: flex-end;
  }

  .total {
    align-items: baseline;

    .total-num {
      font-size: 5.33vw;
      font-weight: bold;

      &.small {
        font-size: 4.2vw;
      }
    }

    .unit {
      margin-left: 1.07vw;
    }
  }

  .operation {
    margin: 2.13vw;
    font-size: 2.67vw;
    font-weight: bold;
    white-space: nowrap;
    color: #696876;

    .icon {
      margin-right: 1.07vw;
      icon-size(3.2vw);
    }
  }

  .attribute-text {
    font-size: 2.13vw;

    &.public {
      color: color-primary;
    }

    &.private {
      color: #CE5849;
    }

    .attribute-icon {
      margin-right: 1.07vw;
      width: 4.8vw;
      height: 4.8vw;
    }
  }

  .action {
    .md-button {
      min-width: 17.6vw;
      height: 5.87vw;
      font-size: 2.67vw;
      border-radius: 1.07vw;
    }
  }
}

.pay-remark {
  font-size: 2.8vw;
  min-height: 6.78vw;
  color: #7f7f87;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.tag-video 
  color:black

.exchange-popup-div {
  font-size: 3.13vw;
  color: #84969c;
  align-items:center;
  .icon {
    width: 3.18vw;
    height: 3.18vw;
   }
}
.exchange-popup-span {
  font-size: 3.13vw;
}
</style>
